import {Button, Typography} from '@mui/material';
import {IconIllustration, Modal} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages';
import React from 'react';
import {DecisionModalProps} from './types';
import {Loading} from '../Loading/Loading';

export function DecisionModal({
	open,
	onClose,
	headerTitle,
	title,
	description,
	firstButton,
	secondButton,
	isFullScreen,
	maxWidth,
	disableClose = false,
	customIconName,
	showIcon = true,
	textAlignDescription = 'center',
}: DecisionModalProps) {
	const {isTablet} = useMediaQueries();
	const fullScreen = isFullScreen !== undefined ? isFullScreen : isTablet;

	return (
		<Modal.Root
			open={open}
			onClose={onClose}
			fullScreen={fullScreen}
			slotProps={{paper: {style: {maxWidth}}}}>
			<Modal.Header onClose={onClose} title={headerTitle} disableClose={disableClose} />
			<Modal.Content
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					gap: 2,
				}}>
				{showIcon ? (
					<IconIllustration variant="primary" customIconName={customIconName} />
				) : null}
				<Typography variant="h6" textAlign="center">
					{title}
				</Typography>
				{description ? (
					<Typography variant="body1" textAlign={textAlignDescription}>
						{description}
					</Typography>
				) : null}
			</Modal.Content>
			<Modal.Footer sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
				{firstButton ? (
					<Button
						size="large"
						variant={firstButton.variant || 'contained'}
						fullWidth
						onClick={firstButton.handleClick}
						disabled={firstButton.disabled}
						endIcon={
							firstButton.isLoading ? <Loading size="18px" color="inherit" /> : null
						}>
						{firstButton.title}
					</Button>
				) : null}
				{secondButton ? (
					<Button
						size="large"
						variant={secondButton.variant || 'outlined'}
						fullWidth
						onClick={secondButton.handleClick}
						disabled={secondButton.disabled}
						endIcon={
							secondButton.isLoading ? <Loading size="18px" color="inherit" /> : null
						}>
						{secondButton.title}
					</Button>
				) : null}
			</Modal.Footer>
		</Modal.Root>
	);
}
